// @flow
import * as React from 'react';
import styled, { css } from 'styled-components';
import type { HOC as ElementType } from 'recompose';
import type { svgType } from './../../types';

const centeredStyled = `
  left: 50%;
  pointer-events: none;
  position: absolute;
  top: 50%;
  vertical-align: middle;
`;

export const Svg = styled.svg`
  cursor: ${({ isPointer }) => (isPointer ? 'pointer' : 'default')};
  display: inline-block;
  ${({ centerAlign, width, height }) => {
    const style =
      centerAlign === true
        ? css`
            margin-left: -${width / 2}px;
            margin-top: -${height / 2}px;
            ${centeredStyled};
          `
        : css``;
    return style;
  }};
  ${({ hoverFill }) =>
    hoverFill
      ? `
          &:hover {
            path.hoverFill {
              fill: var(--color-${hoverFill});
            }
          }
        `
      : ''};
  ${({ hoverStroke }) =>
    hoverStroke
      ? `
          &:hover {
            .hoverFill {
              stroke: var(--color-${hoverStroke});
            }
          }
        `
      : ''};
`;
export const withSvg = (Comp: ElementType) => ({
  width,
  height,
  centerAlign = true,
  hoverFill,
  svgStyle = {},
  hoverStroke,
  pathProps = {},
  onClick = () => null,
  transform,
  isPointer = true,
  ...props
}: svgType) => {
  const { viewBox = `0 0 ${width} ${height}` } = props;
  return (
    <Svg
      width={width}
      height={height}
      style={svgStyle}
      centerAlign={centerAlign}
      hoverFill={hoverFill}
      hoverStroke={hoverStroke}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox}
      transform={transform}
      onClick={onClick}
      isPointer={isPointer}
    >
      <Comp width={width} height={height} {...props} {...pathProps} />
    </Svg>
  );
};
